import React from 'react'

import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const FormWrapper = styled.div`
	padding: 32px 100px 48px;
	box-shadow: 0 7px 70px 0 rgba(0, 0, 0, 0.1);
	background-color: #fff;

	.ant-row {
		display: flex;
		gap: 24px;

		@media (max-width: 1200px) {
		}
		@media (max-width: 768px) {
			gap: 12px;
		}

		.ant-col {
			flex: 1;

			&:not(:nth-of-type(1)) {
				.ant-form-item {
					position: relative;

					&:before {
						display: block;
						content: '';
						position: absolute;
						bottom: 35px;
						left: 0;
						width: 24px;
						height: 1px;
						z-index: 9;
						background-color: rgba(27, 27, 41, 0.3);
						transform: translateX(-100%);

						@media (max-width: 1200px) {
						}
						@media (max-width: 768px) {
							width: 12px;
							bottom: 24px;
						}
					}
				}
			}
		}
	}

	@media (max-width: 1200px) {
		padding: 24px;
		margin: 0 36px;
	}
	@media (max-width: 768px) {
	}
`

export const TrackingNumber: React.FC = () => {
	return (
		<Wrapper>
			<p className={'title'}>
				R인증 번호를 조회하여
				<br />
				정당한 저작권 이용 여부를 확인하세요.
			</p>
			<FormWrapper>{/*<TrackingNumberFormView />*/}</FormWrapper>
		</Wrapper>
	)
}

export const Wrapper = styled.div`
	width: 100%;
	max-width: 996px;
	text-align: center;

	&:not(:nth-of-type(1)) {
		.title {
			margin-top: 104px;

			@media (max-width: 1200px) {
				margin-top: 72px;
			}
			@media (max-width: 768px) {
				margin-top: 48px;
			}
		}
	}

	.title {
		font-size: 24px;
		font-weight: bold;
		color: ${themeGet('color.0', '#1B1B29')};
		margin-top: 48px;
		margin-bottom: 0;

		& + * {
			margin-top: 40px;
		}

		@media (max-width: 1200px) {
			font-size: 20px;
		}
		@media (max-width: 768px) {
			font-size: 18px;
			margin-top: 36px;

			& + * {
				margin: 24px 16px 0;
			}
		}
	}

	.ant-table-wrapper {
		@media (max-width: 1200px) {
			margin-left: 36px;
			margin-right: 36px;
		}
		@media (max-width: 768px) {
			margin-left: 16px;
			margin-right: 16px;
		}

		.ant-spin-container {
			.ant-table {
				border-top: solid 1px #e8e8ea;
				border-bottom: solid 1px #e8e8ea;
				border-radius: 0;
				background-color: #fdfdff;

				.ant-table-container {
					.ant-table-content {
						width: 100%;
						overflow-x: auto;

						table {
							min-width: 500px;
							color: ${themeGet('color.0', '#1B1B29')};
							border-radius: 0;

							tr {
								&:hover {
									td {
										background-color: transparent;
									}
								}
							}

							thead {
								tr {
									th {
										font-size: 16px;
										font-weight: bold;
										color: ${themeGet('color.0', '#1B1B29')};
										text-align: center;
										padding: 13px 0;
										border-bottom: solid 1px #e8e8ea;
										background-color: rgba(27, 27, 41, 0.03);

										&:before {
											display: none;
										}
									}
								}
							}
							tbody {
								tr {
									td {
										padding: 15px 0;

										&,
										div {
											font-size: 16px;
											color: ${themeGet('color.0', '#1B1B29')};
											text-align: center;
										}
									}
								}
							}
						}
						//.ant-table-tbody {
						tr {
							.ant-table-cell {
								@media (max-width: 1200px) {
								}
								@media (max-width: 768px) {
									font-size: 14px;
									padding: 8px 0;
								}
							}
						}

						// <tr> 테이블 데이터가 없을 때
						.ant-table-placeholder {
							.ant-table-cell {
								.ant-empty {
									.ant-empty-image {
										display: none;
										svg {
										}
									}
									.ant-empty-description {
									}
								}
							}
						}
						// <tr> 테이블 데이터가 있을 때
						.ant-table-row {
							.ant-table-cell {
								div {
								}
							}
						}
						//}
					}
				}
			}
			.ant-pagination {
			}
		}
	}
`
//
